import React from 'react'

export const Box = (props: { children: React.ReactNode }) => {
  return <div>{props.children}</div>
}
